import React, { useEffect, useState } from "react";
import { ArrowRight, ArrowUpRight } from "lucide-react";
import { Reveal, Overline } from "../components/site/Reveal";
import { fetchInsights } from "../lib/api";

export const Insights = () => {
  const [items, setItems] = useState([]);
  useEffect(() => {
    fetchInsights().then(setItems).catch(() => setItems([]));
  }, []);

  return (
    <section id="insights" className="relative bg-bg-light py-24 sm:py-32" data-testid="insights-section">
      <div className="mx-auto max-w-[1400px] px-5 sm:px-8">
        <div className="flex flex-wrap items-end justify-between gap-6">
          <div className="max-w-2xl">
            <Reveal><Overline>Insights / Knowledge Hub</Overline></Reveal>
            <Reveal delay={0.05}>
              <h2 className="mt-6 font-serif text-4xl font-light leading-tight text-charcoal sm:text-5xl">
                Perspectives on the <span className="text-gradient-gold">future of work</span>.
              </h2>
            </Reveal>
          </div>
          <Reveal delay={0.1}>
            <button data-testid="explore-insights-btn"
              className="group flex items-center gap-2 rounded-full border border-emerald-base/30 px-6 py-3 text-sm font-semibold text-emerald-base transition-colors duration-300 hover:bg-emerald-base hover:text-off-white">
              Explore Insights <ArrowRight size={16} className="transition-transform duration-300 group-hover:translate-x-1" />
            </button>
          </Reveal>
        </div>

        <div className="mt-14 grid gap-6 md:grid-cols-2 lg:grid-cols-3">
          {items.map((a, i) => (
            <Reveal key={a.id} delay={(i % 3) * 0.1}>
              <article data-testid={`insight-card-${i}`}
                className="group flex h-full flex-col overflow-hidden rounded-[1.5rem] border border-black/5 bg-white card-shadow transition-transform duration-500 hover:-translate-y-1.5">
                <div className="relative aspect-[16/10] overflow-hidden">
                  <img src={a.image} alt={a.title} className="h-full w-full object-cover transition-transform duration-700 group-hover:scale-105" />
                  <span className="absolute left-4 top-4 rounded-full bg-emerald-darkest/85 px-3 py-1 text-xs font-semibold text-gold-light backdrop-blur">
                    {a.category}
                  </span>
                </div>
                <div className="flex flex-1 flex-col p-6">
                  <h3 className="font-serif text-2xl leading-snug text-charcoal transition-colors group-hover:text-emerald-base">{a.title}</h3>
                  <p className="mt-3 flex-1 text-sm leading-relaxed text-charcoal/60">{a.excerpt}</p>
                  <div className="mt-5 flex items-center gap-1.5 text-sm font-semibold text-emerald-base">
                    Read insight <ArrowUpRight size={16} className="transition-transform duration-300 group-hover:translate-x-0.5 group-hover:-translate-y-0.5" />
                  </div>
                </div>
              </article>
            </Reveal>
          ))}
        </div>
      </div>
    </section>
  );
};
